var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTheEnvironment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Factory-Building-Eco-Friendly-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Factory Building Eco Friendly 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8.01 11.84 -0.42 -5.67 -4.63 0 -0.42 5.67 5.47 0z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.47 4.64 -0.22 -3a1 1 0 0 0 -1 -0.95H4.31a1 1 0 0 0 -1 1l-0.22 3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.45 21.49a14.93 14.93 0 0 1 1 -2 5.09 5.09 0 0 1 -0.53 -3.12 4.9 4.9 0 0 1 2.59 -3.4 10.78 10.78 0 0 1 5 -1.22 10.93 10.93 0 0 1 4.11 0.83V8.75a1.53 1.53 0 0 0 -1.53 -1.52H14a1.52 1.52 0 0 0 -1.42 0.94l-2.15 5.17H1.58a1.53 1.53 0 0 0 -1.53 1.53V23a0.51 0.51 0 0 0 0.51 0.51h11.1a2.19 2.19 0 0 1 -0.21 -2.02Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.94 14.43a0.47 0.47 0 0 0 -0.26 -0.32 9.33 9.33 0 0 0 -8.44 0.08 3.49 3.49 0 0 0 -1.87 2.39 3.65 3.65 0 0 0 0.41 2.25 0.49 0.49 0 0 0 0.81 0.11 5.58 5.58 0 0 1 3.25 -2.2c0.59 -0.07 1.3 0.72 0.35 1.08s-3 1.57 -4.44 5.15a0.74 0.74 0 0 0 0.41 1 0.71 0.71 0 0 0 0.28 0.06 0.76 0.76 0 0 0 0.7 -0.47 12.37 12.37 0 0 1 0.86 -1.74 3.13 3.13 0 0 0 2 0.81h0.26c3 -0.28 3.88 -3.06 4.55 -5.3a8.36 8.36 0 0 1 1 -2.48 0.5 0.5 0 0 0 0.13 -0.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTheEnvironment);
export default ForwardRef;